// extracted by mini-css-extract-plugin
module.exports = {"WrapperError":"ErrorUserLkShort_WrapperError__Gv_r9","Info":"ErrorUserLkShort_Info__PnRhL"};